import { Link } from '@flos/react-ui';

const HelpLink = ({
    children,
    onClick
}: {
    children: React.ReactNode;
    onClick: () => void;
}): React.JSX.Element => {
    return (
        <div className="u-flex-box--end">
            <Link theme="logo" onClick={onClick}>
                {children}
            </Link>
        </div>
    );
};

export default HelpLink;
